import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './contact-quickbooks-sync-dlg.tmpl.html'
})
export class ContactQuickBooksSyncDlg implements OnInit {
  public formData: FormGroup;

  constructor(
    public matDialogRef: MatDialogRef<ContactQuickBooksSyncDlg>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formData = this.formBuilder.group({
      contactID: [this.data.contactID, Validators.required],
      minimumPaymentDate: [this.data.minimumPaymentDate || new Date(), Validators.required],
      includeFuturePayments: [false],
      includeNonSuccessfulPayments: [false]
    });
  }

  onNoClick(): void {
    this.matDialogRef.close();
  }
}
